import React from "react";
import { Platform, StyleSheet } from "react-native";
import RText from "../RText/RText";
import { RLink } from "./RLink";
import variables from "../../styles/variables";

interface RLinkButtonProps {
  href?: string | undefined;
  slug?: string | undefined;
  text: string;
  backgroundColor?: string;
  textColor?: string;
  onPressCallback?: () => void;
  style?: {};
  dataSetButton: object;
  dataSetButtonText: object;
}

// This component is a link in button form.
// For simple links see RLink.

// This could be extended to include internal navigation
// but there weren't any uses in the codebase at the time of writing.
// If that is the case, we should use the pressableProps to
// ensure the internal navigation link creates an <a> tag on web.
const RLinkButton = ({
  href = undefined,
  slug = undefined,
  text,
  backgroundColor = variables.colors.palette.rtv.secondary,
  textColor = "white",
  onPressCallback = () => {},
  style = {},
  dataSetButton = {},
  dataSetButtonText = {},
}: RLinkButtonProps) => (
  <RLink
    slug={slug} // passing a slug will create an internal navigation link
    href={href} // passing an href will create an external navigation link
    // no idea what happens if you do both...
    type="href"
    {...(Platform.OS === "web" ? { dataSet: dataSetButton } : {})}
    containerStyle={[
      style,
      { paddingVertical: 6, paddingHorizontal: 16, borderRadius: 36 },
      styles.button,
      // match the border color to the background color
      { backgroundColor: backgroundColor, borderColor: backgroundColor },
    ]}
    onPressCallback={onPressCallback}
  >
    <RText
      color={textColor}
      family="primary"
      weight="bold"
      dynamicTextStyle={{}}
      dataSet={dataSetButtonText}
    >
      {text}
    </RText>
  </RLink>
);

export default RLinkButton;

const styles = StyleSheet.create({
  button: {
    borderRadius: 18,
    borderWidth: 1.5,
    userSelect: "none", // prevents text selection on web
    overflow: "hidden", // stops the background color from overflowing the border radius on mobile
  },
});
